var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutineFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9478 2.44437C19.2569 2.59842 19.4524 2.91434 19.4524 3.25967V5.58458L21.4244 4.90657C21.7616 4.79063 22.1355 4.88829 22.3731 5.15377C22.6107 5.41924 22.6685 5.80223 22.519 6.12609L20.9979 9.4202C21.3398 10.2435 21.5286 11.1462 21.5286 12.0931C21.5286 16.8657 17.6595 20.7348 12.8869 20.7348C8.1143 20.7348 4.24512 16.8657 4.24512 12.0931C4.24512 7.32042 8.1143 3.45125 12.8869 3.45125C14.6042 3.45125 16.2045 3.95188 17.5501 4.81496V3.25967C17.5501 2.91434 17.7456 2.59842 18.0547 2.44437C18.3637 2.29031 18.7336 2.32463 19.0094 2.53283L20.3493 3.54411V3.25967C20.3493 2.76298 19.9459 2.35958 19.4492 2.35958H18.9486L18.9478 2.44437ZM12.8869 8.83795C13.3836 8.83795 13.787 9.24135 13.787 9.73804V11.9789L15.8132 13.1946C16.239 13.4501 16.377 14.003 16.1215 14.4288C15.866 14.8546 15.3131 14.9926 14.8873 14.737L12.4246 13.2593C12.1536 13.0967 11.987 12.8038 11.987 12.4877V9.73804C11.987 9.24135 12.3904 8.83795 12.8871 8.83795H12.8869Z",
    fill: "#680DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutineFilled);
export default __webpack_public_path__ + "static/media/routine_filled.7767bd2333dad3a8c114db88d9422df9.svg";
export { ForwardRef as ReactComponent };